// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "48e827f6e65a6f40b2411b87bf5c29b0a9d5a694/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","41":"a0ec33ed","777":"dfb468f1","788":"c61fe626","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};